import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchWrapper } from "_helpers";
import { defaultPageNumber, defaultPageSize, getDictionaryQuery } from "_store";

// create slice

const name = "salesRepresentatives";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

export const salesRepresentativesActions = { ...slice.actions, ...extraActions };
export const salesRepresentativesReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    salesRepresentatives: {
      items: [],
      paging: {},
      sorting: { value: "name", type: "asc" }
    },
  };
}

function createReducers() {
  return { setSorting };

  function setSorting(state, action) {
    state.salesRepresentatives.sorting = action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/sales-representatives`;

  return {
    getAll: getAll(),
    search: search(),
    create: create(),
    update: update(),
  };

  function getAll() {
    return createAsyncThunk(
      `${name}/getAll`,
      async(payload) =>
        await fetchWrapper.get(getDictionaryQuery(baseUrl, payload)));
  }

  function search() {
    return createAsyncThunk(
      `${name}/search`,
      async ({ pageNumber, pageSize, searchQuery }) =>
        await fetchWrapper.get(
          `${baseUrl}?pageNumber=${pageNumber ?? defaultPageNumber}&pageSize=${
            pageSize ?? defaultPageSize
          }&searchQuery=${searchQuery ?? ""}&isActive=true`
        )
    );
  }

  function create() {
    return createAsyncThunk(`${name}/create`, async (payload) => {
      return await fetchWrapper.post(`${baseUrl}`, payload);
    });
  }

  function update() {
    return createAsyncThunk(
      `${name}/update`,
      async ({ id, payload }) => {
        return await fetchWrapper.patch(`${baseUrl}/${id}`, payload);
      }
    );
  }
}

function createExtraReducers() {
  return {
    ...getAll(),
    ...update(),
  };

  function getAll() {
    var { pending, fulfilled, rejected } = extraActions.getAll;
    return {
      [pending]: (state) => {
        state.salesRepresentatives.items = { loading: true };
      },
      [fulfilled]: (state, action) => {
        state.salesRepresentatives.items = action.payload.items;
        state.salesRepresentatives.paging = action.payload.paging;
      },
      [rejected]: (state, action) => {
        state.salesRepresentatives.items = { error: action.error };
      },
    };
  }

  function update() {
    var { fulfilled } = extraActions.update;
    return {
      [fulfilled]: (state, action) => {
        const { id, payload } = action.meta.arg;
        const item = state.salesRepresentatives?.items?.find((x) => x.id === id);
        Object.assign(item, payload);
      },
    };
  }
}
